var kind      = require("enyo/kind"),
    themeVars = require("app/theme/variables.js");

// Stub, will be replaced at build time with either SvgLogo or ImgLogo
module.exports = kind(/** @lends  app.ui.logo.Logo.prototype */ {

    /**
     * @private
     */
    name: "app.ui.logo.Logo",

    /**
     * @private
     */
    classes: "app-ui-logo-logo",

    /**
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            this.createComponents([{
                name: "logo",
                kind: themeVars.logoKind
            }]);
            sup.apply(this, arguments);
        };
    })

});
